import store from '@/store/index.js'


export async function tagAddInList(list, tagName) {
    let newList = structuredClone(list);

    if (tagName === null || tagName === '') return newList;

    let tagList = await store.getters.TAGS;
    let tagID = null;

    tagList.forEach((tagValue, tagIndex) => {
        if (tagValue.name === tagName) {
            tagID = tagValue.id;
        }
    });

    if (newList.includes(tagID) === false && tagID != null) {
        newList.push(tagID);
    }

    return newList;
}

export async function tagRemoveInList(list, tagID) {
    let newList = structuredClone(list);
    const searchTagIndex = newList.indexOf(Number(tagID));

    if (searchTagIndex >= 0) newList.splice(searchTagIndex, 1);

    return newList;
}